import React from "react"
import PropTypes from "prop-types"

import StandardModal from '../app_components/StandardModal'

class BadgeExplainerModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      openExplainer: false
    }
  }

  render() {
    return(
      <StandardModal
        onClose={() => this.props.closeModal()}
        title={this.props.badge.name}
      >
        <div className="profile-badge-modal">
          <img
            className="profile-badge-modal__image"
            src={this.props.badge.image_url}
            alt=""
          />
          <h2 className="profile-badge-modal__title">{this.props.badge.name}</h2>
          <p className="profile-badge-modal__body">{this.props.badge.body}</p>
        </div>
      </StandardModal>
    )
  }
}

export default BadgeExplainerModal;
